<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="searchCampaignList"
      :expand="expand"
      item-key="campaign_id"
      :loading="isLoading"
      :rows-per-page-items="[10, 50]"
    >
      <template v-slot:items="props">
        <tr>
          <td @click="props.expanded = !props.expanded">
            {{ campaignList.indexOf(props.item) + 1 }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-center">
            <img
              :src="props.item.campaign_image"
              alt
              width="50px"
              height="50px"
            />
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_name_th }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_name_en }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_highlight_th }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_highlight_en }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_category ?props.item.campaign_category.category_name_th : '-' }}
          </td>
          <td>
            <v-btn icon @click="toViewCampaign(props.item.campaign_id)">
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
          </td>
          <td>
            <v-switch
              v-model="props.item.status"
              @change="changeStatus(props.item)"
              color="primary"
            ></v-switch>
          </td>
          <td>
            <v-btn
              icon
              :loading="isDeleting.includes(props.item.campaign_id)"
              @click="deleteCampaign(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text>
            <div>
              <span style="font-weight: 700">Level:</span>
              <span
                v-for="(level, index) in props.item.campaign_level"
                :key="index"
              >
                {{ " " + level.level_name }}
                <span v-if="index < props.item.campaign_level.length - 1"
                  >,</span
                >
              </span>
            </div>
            <div>
              <span style="font-weight: 700">Province:</span>
              <span
                v-for="(province, index) in props.item.campaign_province"
                :key="index"
              >
                {{ " " + province.province_name_th }}
                <span v-if="index < props.item.campaign_province.length - 1"
                  >,</span
                >
              </span>
              <span v-if="props.item.campaign_province.length == 0">
                <span>All province</span>
              </span>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <v-dialog v-model="viewDialog" persistent fullscreen hide-overlay>
      <v-card v-if="isLoadingDetail">
        <v-toolbar flat dark color="black">
          <v-btn icon @click="viewDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>View a campaign</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="text-xs-center">
          <div class="spinner"></div>
          Please stand by
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-toolbar dark color="black">
          <v-btn icon @click="viewDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>View a reward</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div class="dialogcontent--title">Reward Detail</div>
          <v-layout wrap>
            <v-flex class="dialogcontent--subtitle">
              Title (TH):
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_name_th
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle">
              Title (EN):
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_name_en
              }}</span>
            </v-flex>

            <v-flex class="dialogcontent--subtitle" xs12>
              Highlight(TH):
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_highlight_th
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12>
              Highlight(EN):
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_highlight_en
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12>
              Description(TH):
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_description_th
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12>
              Description(EN):
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_description_en
              }}</span>
            </v-flex>
            <v-flex xs12 class="dialogcontent--subtitle">
              Text condition
              <div
                class="dialogcontent--value"
                v-for="(condition, key) in campaignDetail.campaign_condition"
                :key="key"
              >
                - TH: {{ condition.th }} | EN: {{ condition.en }}
              </div>
            </v-flex>
          </v-layout>
          <div class="dialogcontent--title pt-4">Reward Condition</div>
          <v-layout wrap>
            <v-flex class="dialogcontent--subtitle" xs12>
              Province:
              <span
                v-if="campaignDetail.campaign_province.length > 0"
                class="dialogcontent--value"
              >
                <span
                  v-for="(province, key) in campaignDetail.campaign_province"
                  :key="key"
                >
                  {{ province.province_name_en }}
                  <span v-if="key < campaignDetail.campaign_province.length - 1"
                    >,</span
                  >
                </span>
              </span>
              <span v-else class="dialogcontent--value">All</span>
            </v-flex>
            <v-flex xs12 class="dialogcontent--subtitle">
              Level:
              <span
                v-for="(level, key) in campaignDetail.campaign_level"
                :key="key"
                class="dialogcontent--value"
              >
                {{ level.current_level_name }}
                <span v-if="key < campaignDetail.campaign_level.length - 1"
                  >,</span
                >
              </span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12>
              Campaign category:
              <span class="dialogcontent--value">
                {{
                  campaignDetail.campaign_category
                    ? campaignDetail.campaign_category.category_name_en
                    : ""
                }}
              </span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Total reward:
              <span class="dialogcontent--value">
                {{ campaignDetail.campaign_amount_redeemed }} /
                {{ campaignDetail.campaign_total_amount }}
              </span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Amount per user:
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_redeemable_amount_per_user
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Base point:
              <span class="dialogcontent--value"
                >{{ campaignDetail.campaign_base_point }} point</span
              >
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Sale point:
              <span class="dialogcontent--value"
                >{{
                  campaignDetail.campaign_sale_point
                    ? campaignDetail.campaign_sale_point
                    : 0
                }}
                point</span
              >
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Time to redeem:
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_reward_life_span
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Redeemed amount of user:
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_redeemed_amount_of_user
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Start date:
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_start_date
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              End date:
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_end_date
              }}</span>
            </v-flex>
          </v-layout>
          <div class="dialogcontent--title pt-4">Promotion Condition</div>
          <v-layout row wrap>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Promotion code:
              <span class="dialogcontent--value">{{
                campaignDetail.campaign_promotion_code
              }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Promotion order type:
              <span class="dialogcontent--value">
                {{
                  campaignDetail.campaign_promotion_order_type == 1
                    ? "Food delivery"
                    : campaignDetail.campaign_promotion_order_type == 2
                    ? "Messenger"
                    : campaignDetail.campaign_promotion_order_type == 4
                    ? "Wellness"
                    : "Other"
                }}
              </span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Promotion type:
              <span class="dialogcontent--value">
                {{
                  campaignDetail.campaign_promotion_type == 1
                    ? "Product"
                    : campaignDetail.campaign_promotion_type == 2
                    ? "Transport"
                    : "Product & Transport"
                }}
              </span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Promotion category:
              <span class="dialogcontent--value">{{ showCategory }}</span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Promotion total:
              <span class="dialogcontent--value">
                {{ campaignDetail.campaign_promotion_discount_amount }}
                {{ campaignDetail.campaign_promotion_unit == 1 ? "฿" : "%" }}
              </span>
            </v-flex>
            <v-flex class="dialogcontent--subtitle" xs12 sm6>
              Minimum price:
              <span class="dialogcontent--value"
                >{{ campaignDetail.campaign_promotion_fix_price }} ฿</span
              >
            </v-flex>
            <v-flex xs12 class="dialogcontent--subtitle">
              Promotion Store/Product:
              <span
                class="dialogcontent--value"
                v-for="(
                  condition, key
                ) in campaignDetail.campaign_promotion_condition"
                :key="key"
              >
                {{ condition }}
                <span
                  v-if="
                    key < campaignDetail.campaign_promotion_condition.length - 1
                  "
                  >,</span
                >
              </span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "headers",
    "search",
    "filterCategory",
    "isLoading",
    "campaignList",
    "campaignDetail",
  ],
  data() {
    return {
      expand: false,
      viewDialog: false,
      isLoadingDetail: false,
      isDeleting: [],
    };
  },
  computed: {
    searchCampaignList() {
      // return this.campaignList
      return this.campaignList.filter(
        (val) =>
          (val.campaign_name_th.includes(this.search) ||
            val.campaign_name_en.includes(this.search)) &&
          (this.filterCategory == undefined ||
            this.filterCategory == val.campaign_category.category_id ||
            this.filterCategory == val.campaign_category)
      );
    },
    showCategory() {
      let category = [
        {
          name: "Normal",
          value: 1,
        },
        {
          name: "Order first time",
          value: 2,
        },
        {
          name: "Fix product price",
          value: 3,
        },
        {
          name: "Fix product price and fix store",
          value: 4,
        },
        {
          name: "Fix product",
          value: 5,
        },
        {
          name: "Fix store",
          value: 6,
        },
        {
          name: "Order first time - Fix Price",
          value: 9,
        },
      ];
      let findObject = category.find(
        (val) => val.value == this.campaignDetail.campaign_promotion_category
      );
      return findObject ? findObject.name : "";
    },
  },
  methods: {
    async changeStatus(item) {
      let result = await this.$store.dispatch(
        "campaigns/changeStatusCampaignReward",
        item.campaign_id
      );
      if (result == false) {
        item.status = !item.status;
      }
    },
    async deleteCampaign(item) {
      let n = await this.$confirm("Do you want to delete this campaign ?");
      if (n == true) {
        this.isDeleting.push(item.campaign_id);
        await this.$store.dispatch(
          "campaigns/deleteCampaignReward",
          item.campaign_id
        );
        let key = this.isDeleting.findIndex((val) => val == item.campaign_id);
        this.isDeleting.splice(key, 1);
      }
    },
    async toViewCampaign(ID) {
      this.isLoadingDetail = true;
      this.viewDialog = true;
      await this.$store.dispatch("campaigns/getCampaignRewardDetail", ID);
      this.isLoadingDetail = false;
    },
  },
};
</script>

<style scoped>
.dialogcontent--title {
  font-size: 22px;
  text-decoration: underline;
  padding-bottom: 16px;
}
.dialogcontent--subtitle {
  font-size: 20px;
}

.dialogcontent--value {
  font-size: 18px;
  color: grey;
}

.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;

  margin: 20px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes sk-rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }
  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }
  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
</style>
